import { toByteArray } from 'base64-js';

export function useDownloadPdfBlob() {
  return (encodedPdf: string, fileName: string) => {
    const byteArray = toByteArray(encodedPdf);
    const blob = new Blob([byteArray], { type: 'application/pdf' });

    const blobUrl = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    URL.revokeObjectURL(blobUrl);
  };
}

export function decodeBase64ToPdfBlob(encodedBase64: string) {
  const byteArray = toByteArray(encodedBase64);

  return new Blob([byteArray], { type: 'application/pdf' });
}